<div
  class="table__row"
  role="row"
  [ngClass]="{ 'table__row--last': isLast, 'table__row--alt': isOdd }"
  [formGroup]="item"
  title="{{
    chargeItm.lastModifiedAt ? 'Updated By: ' + chargeItm.lastModifiedBy + '\nUpdated On: ' + (chargeItm.lastModifiedAt | date : 'MM/dd/yyyy hh:mm:ss a') : ''
  }}"
>
  <div class="table__cell table__cell--half" role="cell">
    <span opusAuthorize="OpusJob.EditDetails" opusAuthorizeAction="show" [opusRelationshipManagerRoles]="['aa_OPUS-MAA_Admin']">{{
      chargeItm.enabled ? 'Yes' : 'No'
    }}</span>
    <select formControlName="enabled" [class.input--readonly]="!isEditing" class="table__cell input--inline table__cell--full-width">
      <option value="false">No</option>
      <option value="true">Yes</option>
    </select>
  </div>
  <div class="table__cell table__cell--align-left table__cell--one-half" role="cell">
    <span opusAuthorize="OpusJob.EditDetails" opusAuthorizeAction="show" [opusRelationshipManagerRoles]="['aa_OPUS-MAA_Admin']">{{ chargeItm.name }}</span>
    <input
      type="text"
      ng-pattern="^[a-zA-Z0-9_\-\.\s]{1,100}$"
      class="table__cell input--inline table__cell--align-left table__cell--full-width"
      role="cell"
      formControlName="name"
      [class.input--readonly]="!isEditing"
    />
  </div>
  <div class="table__cell table__cell--half" role="cell">
    {{ getJobStateName(chargeItm.state) }}
  </div>
  <div class="table__cell table__cell--half" role="cell">
    {{ chargeItm.nextRunAt | date : 'MM/dd/yyyy hh:mm:ss a' }}
  </div>
  <div class="table__cell table__cell--half" role="cell">
    {{ chargeItm.startedAt | date : 'MM/dd/yyyy hh:mm:ss a' }}
  </div>
  <div class="table__cell table__cell--half" role="cell">
    {{ chargeItm.completedAt | date : 'MM/dd/yyyy hh:mm:ss a' }}
  </div>
  <div class="table__cell table__cell--align-left table__cell--one-half" role="cell">
    {{ chargeItm.message }}
  </div>
  <div class="table__cell table__cell--half" role="cell">
    <span opusAuthorize="OpusJob.EditDetails" opusAuthorizeAction="show" [opusRelationshipManagerRoles]="['aa_OPUS-MAA_Admin']">{{ chargeItm.schedule }}</span>
    <input
      type="text"
      ng-pattern="^(\*|([0-9]|([0-5]?[0-9]-(?:[0-5]?[0-9])?|\*),(?:\*|([0-5]?[0-9]|(?:[0-5]?[0-9]-(?:[0-5]?[0-9])?|\*)))$"
      class="table__cell input--inline table__cell--full-width"
      role="cell"
      formControlName="schedule"
      [class.input--readonly]="!isEditing"
    />
  </div>
  <div class="table__cell table__cell--half" role="cell">
    <span opusAuthorize="OpusJob.EditDetails" opusAuthorizeAction="show" [opusRelationshipManagerRoles]="['aa_OPUS-MAA_Admin']">{{
      chargeItm.retryCount
    }}</span>
    <input
      type="number"
      ng-pattern="/^\d+$/"
      min="0"
      class="table__cell input--inline table__cell--full-width"
      role="cell"
      formControlName="retryCount"
      [class.input--readonly]="!isEditing"
    />
  </div>
  <div class="table__cell table__cell--half" role="cell">
    <span opusAuthorize="OpusJob.EditDetails" opusAuthorizeAction="show" [opusRelationshipManagerRoles]="['aa_OPUS-MAA_Admin']">{{
      chargeItm.retryDelaySeconds
    }}</span>
    <input
      type="number"
      ng-pattern="/^\d+$/"
      min="0"
      class="table__cell input--inline table__cell--full-width"
      role="cell"
      formControlName="retryDelaySeconds"
      [class.input--readonly]="!isEditing"
    />
  </div>
</div>
